export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0062.9347a41c.webp";